<template>
  <div class="student-task-list-page">
    <card header-classes="bg-transparent" body-classes="bg-transparent p-0">
      <div slot="header" class="row align-items-center">
        <div class="col-lg-6">
          <h6 class="text-uppercase ls-1 mb-1">Setting User</h6>
        </div>
        <div class="col-lg-6 text-lg-right">
          <b-button variant="warning" size="sm" @click="downloadExcel()"><i class="fa fa-download" aria-hidden="true"></i> Download Template Blank</b-button>
          <b-button variant="primary" size="sm" @click="downloadDataUser()"><i class="fa fa-download" aria-hidden="true"></i> Download Template </b-button>
          <b-button variant="info" size="sm" @click="showImportFormModal()"><i class="fa fa-upload" aria-hidden="true"></i> Upload Data</b-button>
          <b-button variant="primary" size="sm" @click="showFormModal(null)"><i class="fa fa-user-plus" aria-hidden="true"></i> Tambah User</b-button>
        </div>
      </div>
      <div class="text-center text-muted">
        <div class="card shadow">
          <div class="p-2">
            <b-row>
              <b-col lg="2" class="my-1">
                <p>
                  Total Siswa Aktif: <b>{{ totalActive }}</b>
                </p>
              </b-col>
              <b-col lg="2" class="my-1"> </b-col>
              <b-col lg="2" class="my-1">
                <b-input-group size="sm">
                  <b-form-select v-model="filter_form.class_id" name="class_id" value-field="id" placeholder="Kelas" text-field="name" data-vv-as="Kelas" :options="classesList"> </b-form-select>
                </b-input-group>
              </b-col>
              <b-col lg="2" class="my-1">
                <b-input-group size="sm">
                  <b-form-select v-model="filter_form.ta_id" name="ta_id" value-field="id" placeholder="Tahun Ajaran" text-field="name" data-vv-as="Tahun Ajaran" :options="taList"> </b-form-select>
                </b-input-group>
              </b-col>
              <b-col lg="2" class="my-1">
                <b-input-group size="sm">
                  <b-form-select v-model="filter_form.type" name="type" value-field="id" placeholder="Type" text-field="name" data-vv-as="Type" :options="userTypeList"> </b-form-select>
                </b-input-group>
              </b-col>
              <b-col lg="2" class="my-1">
                <b-input-group size="sm">
                  <b-form-select v-model="filter_form.status" name="status" value-field="id" placeholder="Status" text-field="name" data-vv-as="Status" @change="handleStatusChange" :options="statusList"> </b-form-select>
                  <b-input-group-append>
                    <b-button variant="primary" style="border-radius: 0px !important" @click="getUserSettingList()">Filter</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="1" class="my-1" style="width: 100px">
                <b-form-select id="per-page-select" v-model="perPage" :options="pageOptions" size="sm"></b-form-select>
              </b-col>
              <b-col lg="5" class="my-1">
                <b-button :disabled="isDisabled" variant="danger" size="sm" @click="confirmMultipleDeleteUser()"><i class="fa fa-trash" aria-hidden="true"></i> Hapus</b-button>
                <b-button :disabled="isDisabled || isNonActive" variant="warning" size="sm" @click="confirmMultipleIsNoActive(0)"><i class="fa fa-times-circle" aria-hidden="true"></i> Keluarkan/Luluskan</b-button>
                <b-button :disabled="isDisabled || isReActive" variant="info" size="sm" @click="confirmMultipleIsNoActive(1)"><i class="fa fa-recycle" aria-hidden="true"></i> Aktifkan Kembali</b-button>
                <b-button :disabled="isDisabled || isNonActive" variant="primary" size="sm" @click="confirmNaikKelas()"><i class="fa fa-arrow-up" aria-hidden="true"></i> Naik Kelas</b-button>
              </b-col>
              <b-col lg="3" class="my-1"></b-col>
              <b-col lg="3" class="my-1">
                <b-input-group size="sm">
                  <b-form-input id="filter-input" v-model="filter" type="search" placeholder="Cari"></b-form-input>

                  <b-input-group-append>
                    <b-button variant="primary" style="border-radius: 0px !important" :disabled="!filter" @click="filter = ''">Clear</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-col>
            </b-row>
            <b-table
              :items="userSettingList"
              :fields="fields"
              :busy="isBusy"
              :current-page="currentPage"
              :per-page="perPage"
              :filter="filter"
              :filter-included-fields="filterOn"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              responsive
              show-empty
              small
              @filtered="onFiltered"
            >
              <template #table-busy>
                <div class="text-center text-danger my-2">
                  <img class="img-loading" src="../../../assets/img/logo-daring.png" alt="Logo" /><br />
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template v-slot:head(selected)>
                <b-form-checkbox v-model="selectAll" @change="toggleSelectAll"></b-form-checkbox>
              </template>
              <template v-slot:cell(selected)="row">
                <b-form-checkbox v-model="row.item.selected" @change="setButtonDelete(row.item)"></b-form-checkbox>
              </template>
              <template #cell(image_path)="row">
                <div class="media d-flex justify-content-center">
                  <a href="javascript:void(0)" class="avatar rounded-circle">
                    <img alt="" height="50px" :src="row.item.image_path" />
                  </a>
                </div>
              </template>
              <template #cell(full_name)="row">
                <div class="list-murid text-left">
                  <label>{{ row.item.full_name }}</label>
                </div>
              </template>
              <template #cell(email)="row">
                <div class="list-murid text-left">
                  <label>{{ row.item.email }}</label>
                </div>
              </template>
              <template #cell(gender)="row">
                <div class="list-murid text-center">
                  <label>{{ row.item.gender }}</label>
                </div>
              </template>
              <template #cell(user_status)="row">
                <div class="list-murid text-center">
                  <label>{{ row.item.user_status }}</label>
                </div>
              </template>
              <template #cell(is_active)="row">
                <div class="list-murid text-center">
                  <label>{{ row.item.is_active == "0" ? "Ya" : "Tidak" }}</label>
                </div>
              </template>
              <template #cell(current_class)="row">
                <div class="list-murid text-center">
                  <label>{{ row.item.type == "murid" ? row.item.current_class : "" }}</label>
                </div>
              </template>
              <template #cell(actions)="row">
                <div class="my-2">
                  <a href="javascript:void(0)" v-b-tooltip.hover title="Ubah" class="icon-clicked p-1" @click="showFormModal(row.item)"><i class="fa fa-edit" aria-hidden="true"></i></a>
                  <a href="javascript:void(0)" v-b-tooltip.hover title="reset password" class="icon-clicked p-1" @click="confirmResetPasswordUser(row.item.id)"><i class="fa fa-key" aria-hidden="true"></i></a>
                  <a href="javascript:void(0)" v-b-tooltip.hover title="Hapus" class="icon-clicked p-1" @click="confirmDeleteUser(row.item.id)"><i class="fa fa-trash" aria-hidden="true"></i></a>
                  <a href="javascript:void(0)" v-b-tooltip.hover title="Hapus kelas" class="icon-clicked p-1" @click="showDeleteClassModal(row.item)"><i class="fa fa-eraser" aria-hidden="true"></i></a>
                  <a href="javascript:void(0)" v-b-tooltip.hover title="Gabung kelas" class="icon-clicked p-1" @click="showJoinClassModal(row.item)"><i class="fa fa-user-cog" aria-hidden="true"></i></a>
                </div>
              </template>
            </b-table>
            <div class="d-flex justify-content-lg-end justify-content-center py-2">
              <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="fill" size="sm" class="my-0"></b-pagination>
            </div>
          </div>
        </div>
      </div>
    </card>
    <b-modal ref="user-form-modal" class="user-form-modal" size="md" :title="setTitle" @show="resetForm" @hidden="resetForm" hide-footer no-close-on-backdrop>
      <user-form :id="id" :detail="detail" :genderList="genderList" :userTypeList="userTypeList"></user-form>
    </b-modal>
    <b-modal ref="user-inactive-form-modal" class="user-inactive-form-modal" size="md" :title="setTitle" @hidden="hideFormInactiveModal" hide-footer no-close-on-backdrop>
      <user-inactive-form :id="userIds" :status="statusUser"></user-inactive-form>
    </b-modal>
    <b-modal ref="user-join-class-modal" class="user-join-class-modal" size="md" title="Bergabung Kelas" @show="resetJoinClassModal" @hidden="resetJoinClassModal" hide-footer no-close-on-backdrop>
      <user-join-class-form :id="id"></user-join-class-form>
    </b-modal>
    <b-modal ref="user-delete-class-modal" class="user-delete-class-modal" size="md" title="Hapus Kelas" @show="resetDeleteClassModal" @hidden="resetDeleteClassModal" hide-footer no-close-on-backdrop>
      <user-delete-class-form :id="id"></user-delete-class-form>
    </b-modal>
    <b-modal ref="user-import-form-modal" class="user-import-form-modal" size="md" title="Import Data" @show="resetImportForm" @hidden="resetImportForm" hide-footer no-close-on-backdrop>
      <b-form data-vv-scope="user-import-form">
        <b-form-group label="Data" label-for="data" label-cols-sm="3" label-align-sm="left">
          <b-form-file
            ref="file_path"
            name="file_path"
            data-vv-as="File data"
            v-model="import_form.file_data"
            :state="Boolean(import_form.file_data)"
            type="file"
            placeholder="Pilih file disini. . ."
            drop-placeholder="Drop file here..."
            v-validate="'required'"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          >
          </b-form-file>
          <span :class="{ 'error-validation': errors.first('user-import-form.file_path') }">{{ errors.first("user-import-form.file_path") }}</span>
        </b-form-group>
      </b-form>
      <hr class="m-0" />
      <div class="form-footer d-flex justify-content-end mt-3">
        <square-loader :loading="showLoader" :color="'#ca062a'" :size="'30px'"></square-loader>
        <b-button v-if="!showLoader" variant="outline-danger" size="md" style="width: 25%" @click="hideImportFormModal">BATAL</b-button>
        <b-button v-if="!showLoader" variant="primary" size="md" style="width: 25%" @click.prevent="saveImportSoal">UPLOAD</b-button>
      </div>
    </b-modal>
  </div>
</template>
<style scoped>
.foto-field {
  height: 50px;
}
</style>
<script>
import { mapGetters } from "vuex";
import { EventBus } from "@/eventBus.js";
import axios from "../../../axiosHelper";
import UserForm from "../../../components/Main/User/UserForm";
import UserInactiveForm from "../../../components/Main/User/UserInactiveForm";
import UserJoinClassForm from "../../../components/Main/UserJoinClassForm";
import UserDeleteClassForm from "../../../components/Main/UserDeleteClassForm";
import SquareLoader from "vue-spinner/src/SquareLoader.vue";

export default {
  props: {
    //
  },
  components: {
    UserForm,
    UserInactiveForm,
    UserJoinClassForm,
    UserDeleteClassForm,
    SquareLoader,
  },
  data() {
    return {
      selectAll: false,
      import_form: {
        file_data: null,
      },
      statusList: [
        {
          id: "1",
          name: "Tidak",
        },
        {
          id: "0",
          name: "Ya",
        },
      ],
      filter_form: {
        type: "murid",
        status: "1",
        class_id: 0,
        ta_id: 0,
      },
      setTitle: "",
      id: null,
      totalActive: 0,
      detail: {},
      isBusy: false,
      userIds: [],
      statusUser: "",
      isDisabled: true,
      isNonActive: false,
      isReActive: true,
      showLoader: false,
      items: [],
      fields: [
        { key: "selected", label: "", sortable: false },
        { key: "image_path", label: "Foto", sortable: false, class: "foto-field" },
        { key: "full_name", label: "Nama Lengkap", sortable: true, class: "text-left" },
        { key: "email", label: "Email", sortable: true, sortDirection: "desc", class: "text-left" },
        { key: "gender", label: "Jenis Kelamin", sortable: true, class: "text-center" },
        { key: "user_status", label: "Status", sortable: true, class: "text-center" },
        { key: "is_active", label: "Keluar/Lulus", sortable: true, class: "text-center" },
        { key: "current_class", label: "Kelas Sekarang", sortable: true, class: "text-center" },
        { key: "actions", label: "Aksi", class: "action-field" },
      ],
      genderList: [
        {
          id: null,
          name: "Pilih jenis kelamin",
        },
        {
          id: "L",
          name: "Laki-laki",
        },
        {
          id: "P",
          name: "Perempuan",
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 25,
      pageOptions: [25, 50, 100, 200, 400, 800, 1000],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
    };
  },
    computed: {
      ...mapGetters({
        user: "getUser",
        userSettingList: "getUserSettingList",
        totalACtive: "getUserSettingList",
        userTypeList: "getUserTypeList",
        taList: "getTaList",
        classesList: "getClassesList",
        token: "getToken",
      }),
    },
  watch: {
    userSettingList(val) {
      this.totalRows = val.length;
      this.totalActive = val.length;
    },
  },
  methods: {
    toggleSelectAll(checked) {
      this.userIds = []; // kosongkan dulu
      this.userSettingList.forEach((user) => {
        user.selected = checked;
        if (checked) {
          this.userIds.push(user.id);
        }
      });
      this.isDisabled = !checked;
    },
    handleStatusChange(selectedValue) {
      if (selectedValue == 1) {
        this.isNonActive = false;
        this.isReActive = true;
      } else {
        this.isNonActive = true;
        this.isReActive = false;
      }
    },
    setButtonDelete(data) {
      setTimeout(() => {
        if (data.selected == true) {
          this.userIds.push(data.id);
        } else {
          var index = this.userIds.indexOf(data.id);
          if (index !== -1) {
            this.userIds.splice(index, 1);
          }
        }
        if (this.userIds.length > 0) {
          this.isDisabled = false;
        } else {
          this.isDisabled = true;
        }
      }, 300);
    },
    downloadExcel() {
      let token = this.token;
      let route = axios.defaults.baseURL + "/v1/user-management/download-template-blank?token=" + token;
      window.open(route);
    },
    downloadDataUser() {
      let token = this.token;
      let route = axios.defaults.baseURL + "/v1/user-management/download-template?token=" + token;
      window.open(route);
    },
    showImportFormModal() {
      this.$refs["user-import-form-modal"].show();
    },
    hideImportFormModal() {
      this.$refs["user-import-form-modal"].hide();
      this.resetImportForm();
      this.getUserSettingList();
    },
    resetImportForm() {
      this.import_form.file_data = null;
      this.$validator.reset();
    },
    showJoinClassModal(param) {
      this.id = param.id;
      this.$refs["user-join-class-modal"].show();
    },
    hideJoinClassModal() {
      this.$refs["user-join-class-modal"].hide();
      this.resetJoinClassModal();
      this.getUserSettingList();
    },
    resetJoinClassModal() {
      EventBus.$emit("resetJoinClassForm", true);
    },
    showDeleteClassModal(param) {
      this.id = param.id;
      this.$refs["user-delete-class-modal"].show();
    },
    hideDeleteClassModal() {
      this.$refs["user-delete-class-modal"].hide();
      this.resetDeleteClassModal();
    },
    resetDeleteClassModal() {
      EventBus.$emit("resetDeleteClassForm", true);
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    showFormModal(param) {
      if (param) {
        this.id = param.id;
        this.detail = param;
        this.setTitle = "Edit User";
      } else {
        this.detail = {};
        this.id = null;
        this.setTitle = "Tambah User";
      }
      this.$refs["user-form-modal"].show();
    },
    hideFormModal() {
      this.$refs["user-form-modal"].hide();
      this.resetForm();
    },
    hideFormInactiveModal() {
      this.userIds = [];
      this.statusUser = "";
      this.isDisabled = true;
      if (this.$refs["user-inactive-form-modal"]) {
        this.$refs["user-inactive-form-modal"].hide();
      }
      this.resetForm();
    },
    resetForm() {
      this.getUserSettingList();
      EventBus.$emit("resetForm", true);
    },
    async confirmDeleteUser(userId) {
      this.$swal
        .fire({
          title: "Apakah anda yakin?",
          text: "",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Ya, saya yakin",
          cancelButtonText: "Tidak",
        })
        .then((result) => {
          if (result.value) {
            this.deleteUser(userId);
          }
        });
    },
    async confirmResetPasswordUser(userId) {
      this.$swal
        .fire({
          title: "Apakah anda yakin akan mereset password user ?",
          text: "",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Ya, saya yakin",
          cancelButtonText: "Tidak",
        })
        .then((result) => {
          if (result.value) {
            this.ResetPasswordUser(userId);
          }
        });
    },
    async confirmMultipleDeleteUser() {
      this.$swal
        .fire({
          title: "Apakah anda yakin?",
          text: "",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Ya, saya yakin",
          cancelButtonText: "Tidak",
        })
        .then((result) => {
          if (result.value) {
            this.deleteMultipleUser(this.userIds);
          }
        });
    },
    async confirmMultipleIsNoActive(status) {
      var setTitle = "Nonaktifkan User";
      var setStatus = "0";
      if (status == 1) {
        setTitle = "Aktifkan User";
        setStatus = "1";
      }
      this.statusUser = setStatus;
      this.setTitle = setTitle;
      this.$refs["user-inactive-form-modal"].show();
    },
    async confirmMultipleIsActive() {
      this.$swal
        .fire({
          title: "Apakah anda yakin?",
          text: "",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Ya, saya yakin",
          cancelButtonText: "Tidak",
        })
        .then((result) => {
          if (result.value) {
            this.activationMultipleUser(this.userIds, 1);
          }
        });
    },
    async confirmNaikKelas() {
      this.$swal
        .fire({
          title: "Apakah anda yakin?",
          text: "",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Ya, saya yakin",
          cancelButtonText: "Tidak",
        })
        .then((result) => {
          if (result.value) {
            this.naikKelas(this.userIds, this.filter_form);
          }
        });
    },
    async deleteUser(id) {
      await this.$store
        .dispatch("deleteUser", { id })
        .then((res) => {
          this.getUserSettingList();
          this.$swal.fire("Success", res.message, "success");
        })
        .catch((err) => {
          this.$swal.fire("Failed", err.response.data.message, "error");
        });
    },
    async ResetPasswordUser(id) {
      await this.$store
        .dispatch("resetPasswordUser", { id })
        .then((res) => {
          this.$swal.fire("Success", res.message, "success");
        })
        .catch((err) => {
          this.$swal.fire("Failed", err.response.data.message, "error");
        });
    },
    async deleteMultipleUser(id) {
      await this.$store
        .dispatch("deleteMultipleUser", { id })
        .then((res) => {
          this.userIds = [];
          this.statusUser = "";
          this.getUserSettingList();
          this.$swal.fire("Success", res.message, "success");
        })
        .catch((err) => {
          this.userIds = [];
          this.statusUser = "";
          this.$swal.fire("Failed", err.response.data.message, "error");
        });
    },
    async activationMultipleUser(id, status) {
      await this.$store
        .dispatch("activationMultipleUser", { id, status })
        .then((res) => {
          this.userIds = [];
          this.statusUser = "";
          this.getUserSettingList();
          this.$swal.fire("Success", res.message, "success");
        })
        .catch((err) => {
          this.userIds = [];
          this.statusUser = "";
          this.$swal.fire("Failed", err.response.data.message, "error");
        });
    },
    async naikKelas(id, filter) {
      await this.$store
        .dispatch("naikKelas", { id, filter })
        .then((res) => {
          this.userIds = [];
          this.statusUser = "";
          this.getUserSettingList();
          this.$swal.fire("Success", res.message, "success");
        })
        .catch((err) => {
          this.userIds = [];
          this.statusUser = "";
          this.$swal.fire("Failed", err.response.data.message, "error");
        });
    },
    async getUserSettingList() {
      this.isBusy = true;
      await this.$store
        .dispatch("getUserSettingList", this.filter_form)
        .then((res) => {
          this.totalActive = res.data.message;
          // tambahkan selected ke tiap item
          this.userSettingList.forEach((u) => {
            u.selected = false;
          });
          this.isBusy = false;
        })
        .catch((err) => {
          this.isBusy = false;
          this.$swal.fire("Failed", err.response?.data?.message || "Gagal memuat data user", "error");
        });
    },
    async getUserTypeList() {
      this.isBusy = true;
      await this.$store
        .dispatch("getUserTypeList")
        .then(() => {
          this.isBusy = false;
        })
        .catch((err) => {
          this.isBusy = false;
          this.$swal.fire("Failed", err.response?.data?.message || "Gagal memuat daftar type", "error");
        });
    },
    async getTaList() {
      this.isBusy = true;
      await this.$store
        .dispatch("getTaList")
        .then(() => {
          this.isBusy = false;
        })
        .catch((err) => {
          this.isBusy = false;
          this.$swal.fire("Failed", err.response?.data?.message || "Gagal memuat tahun ajaran", "error");
        });
    },
    async getClassesList() {
      this.isBusy = true;
      await this.$store
        .dispatch("getClassesList")
        .then(() => {
          this.isBusy = false;
        })
        .catch((err) => {
          this.isBusy = false;
          this.$swal.fire("Failed", err.response?.data?.message || "Gagal memuat daftar kelas", "error");
        });
    },
    async saveImportSoal() {
      let scope = "user-import-form";
      this.$validator.validateAll(scope).then((valid) => {
        if (valid) {
          this.showLoader = true;
          let formData = new FormData();
          formData.append("file", this.import_form.file_data);
          this.$store
            .dispatch("importUserData", formData)
            .then((res) => {
              this.showLoader = false;
              this.$swal.fire("Success", res.data.message, "success");
            })
            .catch((err) => {
              let error = err.response;
              this.showLoader = false;
              if (error.status == 400) {
                this.errorValidate(error.data, scope);
              } else {
                this.$swal.fire("Failed", error.data.message, "error");
              }
            });
        }
      });
    },
  },
  mounted() {
    this.totalRows = this.userSettingList.length;
  },
  async created() {
    await this.getTaList();
    if (this.taList && this.taList.length > 0) {
      let activeTa = this.taList.find((ta) => ta.is_current == "1");
      if (activeTa) {
        this.filter_form.ta_id = activeTa.id;
      } else {
        this.filter_form.ta_id = this.taList[0].id;
      }
    }
    await this.getUserSettingList();
    await this.getUserTypeList();
    await this.getTaList();
    await this.getClassesList();
    EventBus.$on("hideFormModal", (val) => {
      if (val) {
        this.hideFormModal();
      }
    });
    EventBus.$on("hideFormInactiveModal", (val) => {
      if (val) {
        this.hideFormInactiveModal();
      }
    });
    // EventBus.$emit('hideLoader', true)
    EventBus.$on("hideJoinClassModal", (val) => {
      if (val) {
        this.hideJoinClassModal();
      }
    });
    EventBus.$on("hideDeleteClassModal", (val) => {
      if (val) {
        this.hideDeleteClassModal();
      }
    });
    EventBus.$on("showJoinClassModal", (val) => {
      if (val) {
        this.showJoinClassModal(val);
      }
    });
  },
};
</script>
<style lang="css" scoped>
.line-with-icon svg {
  /* color: #adb7be; */
  position: absolute;
  left: 0;
  top: 0;
  font-size: 1rem;
}
.line-with-icon {
  position: relative;
  padding: 0 0 0 1.75em;
  margin: 0 0 1em;
}
.user-article a {
  color: black;
}
.class-list > .line-with-icon > a {
  color: #ca062a;
}
.user-article a:hover {
  color: #ca062a;
}

.btn-open-answer {
  color: #6c757d;
}
.btn-open-answer:hover {
  color: #ca062a;
}
</style>
